import React, { FC } from 'react'
import styles from 'styles/components/tag.module.scss'

type Props = {
  dataCy?: string
  shape?: 'ellipse' | 'square'
  size?: 'medium' | 'large'
  tagName: string
}

const BlueTag: FC<Props> = (props) => {
  const { dataCy, shape, size, tagName } = props
  const baseStyle = styles.tag_blue
  const shapeStyle = shape === 'ellipse' ? styles.tag__ellipse : ''
  const sizeStyle = size === 'large' ? styles.tag_large : ''
  const dataCyStr = dataCy ? `blue-tag-${dataCy}` : 'blue-tag'

  return (
    <span className={`${baseStyle} ${shapeStyle} ${sizeStyle}`} data-cy={dataCyStr}>
      {tagName}
    </span>
  )
}

export default BlueTag
